import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/news';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-background-50/60 backdrop-blur-sm border-b border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 md:h-[72px] items-center justify-between gap-4">
          {/* 品牌：突出，首页 H1 包裹品牌 */}
          <a href="#top" className="flex items-center gap-3 cursor-pointer shrink-0">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
            </span>
            <h1 className="flex flex-col leading-none">
              <span className="font-heading text-xl md:text-2xl font-black text-foreground-950 tracking-tight">
                黑料网1
              </span>
              <span className="mt-1 text-[11px] md:text-xs text-foreground-500 tracking-[0.2em]">
                更新速览台
              </span>
            </h1>
          </a>

          {/* 桌面导航 */}
          <nav className="hidden lg:flex items-center gap-1 mx-auto">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-100/60 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3 shrink-0">
            <label className="hidden md:flex items-center gap-2 h-10 pl-3 pr-3 rounded-md bg-background-100 border border-background-200 focus-within:border-primary-300 transition-colors">
              <i className="ri-search-line text-foreground-400 text-base" aria-hidden="true"></i>
              <input
                type="text"
                placeholder="搜条目 / 关键词"
                className="w-32 lg:w-44 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
              />
            </label>

            <span className="hidden sm:flex items-center gap-2 h-10 px-3 rounded-md bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-dot"></span>
              实时更新中
            </span>

            <button
              type="button"
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="展开导航"
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {/* 移动端菜单 */}
      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2 text-sm text-foreground-800 bg-background-100 rounded-md hover:text-primary-600 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}